<template>
	<div class="info" :class="{visible}">
		<p v-if="mobile">Använd två fingrar för att navigera i kartan.</p>
		<p v-else>Håll in CTRL för att zooma i kartan.</p>
	</div>
</template>

<script>
export default {
	

	data() {
		return {
			visible: false,
			timeoutId: undefined,
			mobile: false,
		}
	},

	methods: {
		show(mobile) {
			this.mobile = mobile;
			this.visible = true;
			if(this.timeoutId != undefined)
				clearTimeout(this.timeoutId);

			this.timeoutId = setTimeout(() => {
				this.visible = false;
			}, 1500)
		},

		hide() {
			if(this.timeoutId != undefined)
				clearTimeout(this.timeoutId);
			this.visible = false;
		}
	}
}
</script>

<style scoped>
	.info {
		z-index: 1000000000;
		top:0;
		bottom: 0;
		left: 0;
		right: 0;
		padding-bottom: 120px;
		position: absolute;
		margin: auto;
		display: flex;
		flex-flow: column nowrap;
		align-items: center;
		justify-content: flex-end;
		pointer-events: none;
		opacity: 0;
		transition: opacity 0.1s linear;
	}

	.info.visible {
		opacity: 1;
	}

	.info p {
		background-color: white;
		border-radius: 6px;
		color: #444;
		font-weight: bold;
		padding: 8px 12px;
		border: solid 1px #444;
	}
</style>